<template>
  <div class="password-wrapper">
    <input :type="type"
           class="form-control"
           :value="value"
           @input="$dispatch('input', $event.target.value)"
           :id="id"
           :name="id"
    />
    <span class="password-toggle"
          @click="isPasswordType = !isPasswordType"
    >
      <font-awesome-icon :icon="isPasswordType ? eyeIcon : eyeSlashIcon" />
    </span>
  
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
  export default{
    components:{ FontAwesomeIcon },
    props:{
        value: String,
        id : String,
    },
    data(){
      return {
        eyeIcon: faEye,
        eyeSlashIcon: faEyeSlash,
        isPasswordType : true,
      }
    },
    computed:{
      type(){
        return this.isPasswordType ? 'password' : 'text';
      }
    },
  }
</script>
<style scoped lang="scss">
  .password-wrapper{
    position:relative;
    input{
      background-image: none !important; //Get rid of last pass icon
      padding-right:55px;
    }
    .password-toggle{
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right:20px;
    }
  }
</style>

<style lang="scss">
  // Add selectors to this list to disable last pass icon for particular password fields
  .__lpform_api_password, #__lpform_api_password, #__lpform_api_password_numspan,
  .__lpform_ftp_password, #__lpform_ftp_password, __lpform_ftp_password_numspan
  {
    display:none !important;
  }
</style>
